import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const GoogleCallBack = createAsyncThunk(
    "GoogleCallBack",
    async (data, { dispatch }) => {
        try {
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL?.USER_GOOGLE_LOGIN,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            return response;
        } catch (error) { }
    }
);

export const GoogleToken = createAsyncThunk(
    "GoogleToken",
    async (data, { dispatch }) => {

        try {
            // Build URL with optional selectedScopes parameter
            let url = `${API_URL.BASEURL + API_URL?.GOOGLE_TOKEN + "?currenttoken=" + data.encryptedValue + "&passwordvault_displayname=" + data.displayname + "&passwordvault_type=" + data.type}`;

            // Add selectedScopes if provided
            if (data.selectedScopes && data.selectedScopes.length > 0) {
                url += `&selectedScopes=${encodeURIComponent(data.selectedScopes.join(","))}`;
            }

            // Add passwordvaultid if provided
            if (data.passwordvaultid) {
                url += `&passwordvaultid=${encodeURIComponent(data.passwordvaultid)}`;
            }

            let resData = await apiCall(
                {
                    method: "GET",
                    url: url,
                },
                false
            );
            let response = apiResponse(true, resData);
            return response;
        } catch (error) { }
    }
);
const initialState = {
    GoogleCallBackData: {
        data: null,
        error: null,
    },
    GoogleTokenData: {
        data: null,
        error: null,
    },
};

const GoogleSlice = createSlice({
    name: "GOOGLE",
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(GoogleCallBack.fulfilled, (state, action) => {
                state.GoogleCallBackData.data = action.payload;
            })
            .addCase(GoogleCallBack.rejected, (state, action) => {
                state.GoogleCallBackData.error = action.error.message;
            })
            .addCase(GoogleToken.fulfilled, (state, action) => {
                state.GoogleTokenData.data = action.payload;
            })
            .addCase(GoogleToken.rejected, (state, action) => {
                state.GoogleTokenData.error = action.error.message;
            });
    },
});

export default GoogleSlice.reducer;
